var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "card-container", attrs: { shadow: "hover" } },
    [
      _vm.hasActionButton ||
      _vm.hasActionButtonAvocar ||
      _vm.showButtonCadastraOS ||
      _vm.tituloCard
        ? _c(
            "div",
            { staticClass: "btn-cadastrar" },
            [
              _c("h1", { style: { "font-size": _vm.fontSizeTituloCard } }, [
                _vm._v(_vm._s(_vm.tituloCard))
              ]),
              _vm.hasActionButton
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: _vm.typeActionButton,
                        icon: _vm.iconActionButton,
                        size: _vm.sizeActionButton
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("click")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "center" }, [
                        _vm._v(_vm._s(_vm.nameActionButton))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.showButtonCadastraOS
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: _vm.sizeActionButton,
                        type: "success",
                        icon: "el-icon-plus"
                      },
                      on: { click: _vm.selected }
                    },
                    [
                      _c("span", { staticClass: "center" }, [
                        _vm._v("Cadastrar  ")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _vm.infoPrazos && _vm.possuiGestaoPrazo
            ? _c("app-relatorio-prazos", {
                attrs: { infoPrazos: _vm.infoPrazos }
              })
            : _vm._e(),
          _vm.hasActionButtonAvocar
            ? _c(
                "el-button",
                {
                  staticClass: "margin-left-100 buttonAvocar",
                  attrs: {
                    disabled: _vm.disableButtonAvocar,
                    type: "success",
                    plain: "plain",
                    size: _vm.sizeActionButton
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("avocar")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "center" }, [
                    _vm._v("Avocar Processo")
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasHeader || _vm.hasRefreshButton
            ? _c(
                "app-divider-refresh-button",
                {
                  attrs: {
                    label: _vm.headerLabel,
                    hasButton: _vm.hasRefreshButton,
                    content: _vm.tooltipRefreshButton,
                    showBorder: false
                  },
                  on: { click: _vm.updateListagem }
                },
                [
                  _c("template", { slot: "info" }, [
                    _vm.hasFiltroRapido
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "São considerados processos com pendência aqueles que tem uma notificação ou solicitação de informação aguardando resposta",
                                  placement: "right"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-info icon" })]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm.showObsOficioMA
        ? _c("el-alert", {
            attrs: {
              title: "Selecione apenas processos do mesmo tipo para analisar",
              type: "warning",
              "show-icon": "show-icon",
              closable: false
            }
          })
        : _vm._e(),
      _vm.showValidacaoColetiva
        ? _c("el-alert", {
            attrs: {
              title:
                "Selecione processos não onerosos para realizar validação coletiva",
              type: "warning",
              "show-icon": "show-icon",
              closable: false
            }
          })
        : _vm._e(),
      _vm.estado === "ba" && _vm.filtro && _vm.filtro.caixa === "ASSINATURAS"
        ? _c("el-alert", {
            attrs: {
              title:
                "Selecione apenas processos com a mesma situação para analisar",
              type: "warning",
              "show-icon": "show-icon",
              closable: false
            }
          })
        : _vm._e(),
      _c("el-row", [
        _vm.showBorder ? _c("div", { staticClass: "divider" }) : _vm._e()
      ]),
      _vm.busca
        ? _c(
            "el-row",
            [
              _c(
                "el-input",
                {
                  attrs: {
                    size: "medium",
                    placeholder: "Informe o nome do analista"
                  },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { slot: "append" }, slot: "append" },
                    [_c("i", { staticClass: "el-icon-search color-default" })]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.hasFiltroRapido
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "row-label" }, [
              _vm.optionsSelect.length > 1
                ? _c("div", { staticClass: "label-test" }, [
                    _c("b", [_vm._v(_vm._s(_vm.optionsSelect[0].titulo) + ":")])
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "margin-left-10 label-test" },
                _vm._l(_vm.optionsSelect[0].pendencia, function(pendencia) {
                  return _c(
                    "el-checkbox",
                    {
                      key: pendencia.id,
                      on: {
                        change: function($event) {
                          return _vm.handleCheckedFiltroRapido(
                            pendencia,
                            _vm.optionsSelect[0]
                          )
                        }
                      },
                      model: {
                        value: pendencia.value,
                        callback: function($$v) {
                          _vm.$set(pendencia, "value", $$v)
                        },
                        expression: "pendencia.value"
                      }
                    },
                    [_vm._v(_vm._s(pendencia.label))]
                  )
                }),
                1
              )
            ]),
            _vm.optionsSelect.length >= 2 && _vm.optionsSelect[1]
              ? _c("div", { staticClass: "row-label margin-left-20" }, [
                  _c("div", { staticClass: "label-test" }, [
                    _c("b", [
                      _vm._v(_vm._s(_vm.optionsSelect[1].titulo) + " :")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "margin-left-10 label-test" },
                    _vm._l(_vm.optionsSelect[1].pendencia, function(pendencia) {
                      return _c(
                        "el-checkbox",
                        {
                          key: pendencia.id,
                          on: {
                            change: function($event) {
                              return _vm.handleCheckedFiltroRapido(
                                pendencia,
                                _vm.optionsSelect[1]
                              )
                            }
                          },
                          model: {
                            value: pendencia.value,
                            callback: function($$v) {
                              _vm.$set(pendencia, "value", $$v)
                            },
                            expression: "pendencia.value"
                          }
                        },
                        [_vm._v(_vm._s(pendencia.label))]
                      )
                    }),
                    1
                  )
                ])
              : _vm._e(),
            _vm.optionsSelect.length === 3 && _vm.optionsSelect[2]
              ? _c("div", { staticClass: "row-label margin-left-20" }, [
                  _c("div", { staticClass: "label-test" }, [
                    _c("b", [
                      _vm._v(_vm._s(_vm.optionsSelect[2].titulo) + " :")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "margin-left-10 label-test" },
                    _vm._l(_vm.optionsSelect[2].pendencia, function(pendencia) {
                      return _c(
                        "el-checkbox",
                        {
                          key: pendencia.id,
                          on: {
                            change: function($event) {
                              return _vm.handleCheckedFiltroRapido(
                                pendencia,
                                _vm.optionsSelect[2]
                              )
                            }
                          },
                          model: {
                            value: pendencia.value,
                            callback: function($$v) {
                              _vm.$set(pendencia, "value", $$v)
                            },
                            expression: "pendencia.value"
                          }
                        },
                        [_vm._v(_vm._s(pendencia.label))]
                      )
                    }),
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c(
        "el-table",
        {
          ref: "tableData",
          class: {
            "hide-header-checkbox": _vm.isPa && this.isVariosTiposProcesso()
          },
          style: { cursor: _vm.hasRowClick ? "pointer" : "default" },
          attrs: {
            data: _vm.paginate
              ? _vm.paginatedData[_vm.pagina]
              : _vm.jsonData.filter(function(data) {
                  return (
                    !_vm.search ||
                    (data.nome &&
                      data.nome
                        .toLowerCase()
                        .includes(_vm.search.toLowerCase()))
                  )
                }),
            "default-sort": { prop: "id", order: "descending" },
            "row-key": _vm.getRowKeys,
            "expand-row-keys": _vm.expandRowKeys
          },
          on: {
            "expand-change": _vm.rowClicked,
            "sort-change": _vm.sort,
            "selection-change": _vm.selectAll,
            "row-click": _vm.rowClick
          }
        },
        [
          !_vm.jsonData
            ? _c("template", { slot: "empty" }, [_vm._v("Não há registros.")])
            : _c("template", { slot: "empty" }, [
                _vm._v(_vm._s(_vm.dadosNaoEncontrado))
              ]),
          _vm.hasExpansivel
            ? [
                _c("el-table-column", {
                  attrs: { type: "expand", width: "50" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !_vm.subProcessos.source ||
                            _vm.subProcessos.source.length === 0
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      "Não há processos vinculados nessa OS"
                                    )
                                  ])
                                ])
                              : _vm._l(_vm.subProcessos.source, function(
                                  processo,
                                  indexOrdem
                                ) {
                                  return _c(
                                    "el-card",
                                    {
                                      key: "indexOrdem",
                                      staticClass: "card-container",
                                      attrs: { shadow: "hover" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex" },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                "Numero processo: " +
                                                  processo.numeroProcesso
                                              )
                                            )
                                          ]),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                id: "tooltip",
                                                effect: "dark",
                                                content: "Visualizar Processo",
                                                placement: "bottom"
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "botao-visualizar",
                                                attrs: { icon: "eye" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goVisualizarProcesso(
                                                      processo
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "divider" }),
                                      _c("div", { staticClass: "margin-top" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "font-14px espacamento"
                                          },
                                          [
                                            _c("b", [_vm._v("Interessado:")]),
                                            _vm._v(
                                              "  " +
                                                _vm._s(
                                                  processo.nomeRazaoSocialInteressado
                                                )
                                            )
                                          ]
                                        ),
                                        _c("p", { staticClass: "font-14px" }, [
                                          _c("b", { staticClass: "14px" }, [
                                            _vm._v("CPF/CNPJ:")
                                          ]),
                                          _vm._v(
                                            "  " +
                                              _vm._s(
                                                processo.cpfCnpjInteressado
                                              )
                                          )
                                        ])
                                      ]),
                                      _vm._l(processo.processos, function(
                                        membro
                                      ) {
                                        return _c(
                                          "div",
                                          { staticClass: "margin-top" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "font-14px espacamento"
                                              },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      "Análise " +
                                                        membro.funcoes +
                                                        ":"
                                                    )
                                                  )
                                                ]),
                                                _vm._v(
                                                  "  " + _vm._s(membro.status)
                                                )
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "font-14px" },
                                              [
                                                _c("b", [
                                                  _vm._v("Responsável:")
                                                ]),
                                                _vm._v(
                                                  "  " +
                                                    _vm._s(membro.responsavel)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                }),
                            _c("div", [
                              _vm.subProcessos.pageSize > 0
                                ? _c(
                                    "div",
                                    { staticClass: "pagination" },
                                    [
                                      _c("el-pagination", {
                                        attrs: {
                                          layout: "prev, pager, next",
                                          small: "small",
                                          total: _vm.subProcessos.pageSize,
                                          "current-page":
                                            _vm.subProcessos.page + 1,
                                          "page-size": 10
                                        },
                                        on: {
                                          "current-change":
                                            _vm.alterarPaginaSubProcesso
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3947231942
                  )
                })
              ]
            : _vm._e(),
          _vm.hasMultipleCheckbox
            ? _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  selectable: _vm.checkboxHabilitado
                }
              })
            : _vm._e(),
          _vm._l(_vm.jsonHeaders, function(header, indexHeader) {
            return [
              _vm.jsonHeaders[indexHeader].marcado &&
              _vm.jsonHeaders[indexHeader].marcado() &&
              !_vm.hasMultipleCheckbox
                ? _c("el-table-column", {
                    attrs: { width: _vm.isMaranhao ? 1 : 40 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-tooltip", {
                                attrs: {
                                  placement: "right",
                                  disabled:
                                    (_vm.usuario &&
                                      !_vm.usuario.perfilSelecionado.setor
                                        .codigo !== "CAF") ||
                                    (!scope.row.disabled &&
                                      !scope.row.retificacao &&
                                      !scope.row.conversaAberta),
                                  content: scope.row.retificacao
                                    ? "Processo em retificação"
                                    : scope.row.disabled
                                    ? "Análise finalizada"
                                    : "Conversa aberta"
                                }
                              }),
                              !_vm.isMaranhao
                                ? _c("el-checkbox", {
                                    attrs: {
                                      disabled: _vm.desabilita(scope.row)
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selecionaItem(scope.row)
                                      }
                                    },
                                    model: {
                                      value: scope.row.selecionado,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "selecionado", $$v)
                                      },
                                      expression: "scope.row.selecionado"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm.jsonHeaders[indexHeader].type === "icone-credenciado"
                ? _c("el-table-column", {
                    attrs: { align: "left", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "el-icon-user-solid",
                                      style: _vm.isPa
                                        ? {
                                            color: _vm.getColorIconCredenciado(
                                              scope.row
                                            )
                                          }
                                        : {},
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.getTextoCredenciado(
                                          scope.row
                                        ),
                                        placement: "left"
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "el-icon-user-solid"
                                      }),
                                      _c("el-col", { attrs: { span: 10 } })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm.jsonHeaders[indexHeader].type === "icone"
                ? _c("el-table-column", {
                    attrs: { align: "left", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-row",
                                { attrs: { gutter: 30 } },
                                [
                                  _c("el-col", { attrs: { span: 10 } }, [
                                    scope.row.statusFilaAnaliseAutomatizada ===
                                      "ERRO" &&
                                    (scope.row.tipo === "REURB-S" ||
                                      scope.row.tipoCodigo === "NAO_ONEROSO" ||
                                      scope.row.tipoCodigo === "ONEROSO") &&
                                    (scope.row.setor.includes("GCG") ||
                                      scope.row.setor.includes("CGIR"))
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    _vm.$messages
                                                      .ERRO_ANALISE_AUTOMATIZADA,
                                                  placement: "left"
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "el-icon-warning color-laranja"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    scope.row.codigoStatus ===
                                    "AGUARDANDO_CONVERSAO_UTM_GEOGRAFICA"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    "Processo aguardando conversão de UTM para Geográfica",
                                                  placement: "left"
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "el-icon-warning"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]),
                                  _c("el-col", { attrs: { span: 10 } }, [
                                    scope.row.credenciadoGEO ||
                                    scope.row.credenciadoVistoria
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass:
                                                  "el-icon-user-solid",
                                                style: _vm.isPa
                                                  ? {
                                                      color: _vm.getColorIconCredenciado(
                                                        scope.row
                                                      )
                                                    }
                                                  : {},
                                                attrs: {
                                                  effect: "dark",
                                                  content: _vm.mensagemCredenciado(
                                                    scope.row
                                                  ),
                                                  placement: "left"
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "el-icon-user-solid"
                                                }),
                                                _c("el-col", {
                                                  attrs: { span: 10 }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]),
                                  scope.row.conversaAberta
                                    ? _c(
                                        "el-col",
                                        { attrs: { span: 10 } },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                placement: "right",
                                                effect: "dark",
                                                content: !_vm.isAp
                                                  ? _vm.labelNotificacao(
                                                      scope.row,
                                                      scope.row
                                                        .conversaAbertaDias
                                                    )
                                                  : _vm.labelNotificacaoAp(
                                                      scope.row,
                                                      scope.row
                                                        .conversaAbertaDias
                                                    )
                                              }
                                            },
                                            [
                                              scope.row.conversaAberta
                                                ? _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                      class: _vm.changeColor(
                                                        scope.row
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getExactIcon(
                                                            scope.row
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon:
                                                        _vm.jsonHeaders[
                                                          indexHeader
                                                        ].icone,
                                                      size: "lg"
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.desarquivado
                                    ? _c(
                                        "el-col",
                                        { attrs: { span: 10 } },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                placement: "right",
                                                effect: "dark",
                                                content:
                                                  "Processo desarquivado."
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "color-default",
                                                attrs: {
                                                  icon: "folder-open",
                                                  size: "lg"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.isArquivamento(scope) && _vm.isPa
                                    ? _c(
                                        "el-col",
                                        { attrs: { span: 10 } },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content:
                                                  "Processo aguardando análise de arquivamento",
                                                effect: "dark",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "dark",
                                                attrs: {
                                                  icon: "archive",
                                                  size: "lg"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              scope.row.isDadosPreenchidos
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            placement: "right",
                                            effect: "dark",
                                            content:
                                              "Dados do processo preenchidos."
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "color-default",
                                            attrs: { icon: "check", size: "lg" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.getStatusAmbientalOrBloqueio(scope)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: _vm.getRowTooltip(scope),
                                            effect: "dark",
                                            placement: "top",
                                            "raw-content": true
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _c("i", {
                                              class:
                                                "fa fa-exclamation-triangle " +
                                                _vm.getIconStatus(scope)
                                            })
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.jsonHeaders[indexHeader].isIconeSimples
                                ? _c("div", [
                                    _c("i", {
                                      class:
                                        (_vm.jsonHeaders[indexHeader]
                                          .prefixoIcone || "fa") +
                                        " fa-" +
                                        _vm.jsonHeaders[indexHeader].icone,
                                      style: _vm.getIconStyles(
                                        _vm.jsonHeaders[indexHeader]
                                      )
                                    })
                                  ])
                                : _vm._e(),
                              scope.row.dataCancelamento
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "Este processo foi atualizado e republicado devido a alterações recentes.",
                                            placement: "left"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "el-icon-warning color-laranja"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.isNovoExtratoSentencaGerado &&
                              scope.row.setor === "NUTIT" &&
                              _vm.filtro.caixa === "PUBLICACAO"
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "Já foi gerado um extrado de sentença com esse processo.",
                                            placement: "left"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-document-checked"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              !_vm.jsonHeaders[indexHeader].isPrazo &&
              (!_vm.jsonHeaders[indexHeader].acoes ||
                _vm.jsonHeaders[indexHeader].acoes.length === 0) &&
              (!_vm.jsonHeaders[indexHeader].exibir ||
                _vm.jsonHeaders[indexHeader].exibir()) &&
              !_vm.jsonHeaders[indexHeader].propriedade.includes(
                "dadosCartorio"
              )
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.jsonHeaders[indexHeader].titulo,
                      prop: _vm.jsonHeaders[indexHeader].propriedade,
                      sortable: _vm.getOrdenacao(_vm.jsonHeaders[indexHeader]),
                      width: _vm.setWidth(
                        _vm.jsonHeaders[indexHeader].propriedade
                      ),
                      formatter: _vm.jsonHeaders[indexHeader].formatter
                        ? _vm.jsonHeaders[indexHeader].formatter
                        : function(row, col, value, index) {
                            return value ? value : "-"
                          },
                      align: _vm.setAlign(
                        _vm.jsonHeaders[indexHeader].propriedade
                      )
                    }
                  })
                : _vm._e(),
              _vm.jsonHeaders[indexHeader].isPrazo &&
              _vm.jsonHeaders[indexHeader].exibir() &&
              _vm.possuiGestaoPrazo
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.jsonHeaders[indexHeader].titulo,
                      prop: _vm.jsonHeaders[indexHeader].propriedade,
                      sortable: _vm.getOrdenacao(_vm.jsonHeaders[indexHeader]),
                      align: "center",
                      "header-align": "center",
                      width: "150"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.dataVencimento
                                ? _c("div", { staticClass: "col-prazo" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "background-prazo",
                                        style: {
                                          "background-color": _vm.getPrazoColor(
                                            scope.row.dataVencimento
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-prazo" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getDataVencimentoFormatada(
                                                  scope.row.dataVencimento
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _c("span", [_vm._v("-")])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm.jsonHeaders[indexHeader].acoes.length > 0
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.jsonHeaders[indexHeader].titulo,
                      prop: _vm.jsonHeaders[indexHeader].propriedade,
                      align: "center",
                      "align-header": "center",
                      width: "150"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return _vm.showAcao(scope.row)
                              ? [
                                  _c(
                                    "el-dropdown",
                                    {
                                      staticClass: "botao-acoes",
                                      attrs: { trigger: "click", size: "small" }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            id:
                                              scope.row.numeroProcesso +
                                              "-acoes"
                                          }
                                        },
                                        [
                                          _vm._v("Ações"),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-arrow-down el-icon--right"
                                          })
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown"
                                        },
                                        [
                                          _vm.jsonHeaders[indexHeader].acoes !==
                                            null &&
                                          _vm.jsonHeaders[indexHeader].acoes
                                            ? _c(
                                                "div",
                                                _vm._l(
                                                  _vm.jsonHeaders[indexHeader]
                                                    .acoes,
                                                  function(acao, indexAcao) {
                                                    return !acao.show ||
                                                      (acao.show &&
                                                        acao.show(
                                                          _vm.jsonData[
                                                            scope.$index
                                                          ],
                                                          acao
                                                        ))
                                                      ? _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              id:
                                                                scope.row
                                                                  .numeroProcesso +
                                                                "-" +
                                                                acao.id +
                                                                "-" +
                                                                acao.codigo
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "el-dropdown-item",
                                                              [
                                                                _c(
                                                                  "el-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      placement:
                                                                        "right",
                                                                      disabled: acao.showToltip
                                                                        ? acao.showToltip(
                                                                            scope.row,
                                                                            _vm
                                                                              .jsonHeaders[
                                                                              indexHeader
                                                                            ]
                                                                              .acoes[
                                                                              indexAcao
                                                                            ]
                                                                              .codigo
                                                                          )
                                                                        : true,
                                                                      content: acao.textToltip
                                                                        ? acao.textToltip(
                                                                            scope.row
                                                                          )
                                                                        : ""
                                                                    }
                                                                  },
                                                                  [
                                                                    !acao.showToltip ||
                                                                    acao.showToltip(
                                                                      scope.row,
                                                                      _vm
                                                                        .jsonHeaders[
                                                                        indexHeader
                                                                      ].acoes[
                                                                        indexAcao
                                                                      ].codigo
                                                                    )
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            attrs: {
                                                                              id:
                                                                                scope
                                                                                  .row
                                                                                  .numeroProcesso +
                                                                                "-acao-" +
                                                                                _vm
                                                                                  .jsonHeaders[
                                                                                  indexHeader
                                                                                ]
                                                                                  .acoes[
                                                                                  indexAcao
                                                                                ]
                                                                                  .codigo
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.$emit(
                                                                                  "executar",
                                                                                  {
                                                                                    item:
                                                                                      _vm
                                                                                        .jsonData[
                                                                                        scope
                                                                                          .$index
                                                                                      ],
                                                                                    acao:
                                                                                      _vm
                                                                                        .jsonHeaders[
                                                                                        indexHeader
                                                                                      ]
                                                                                        .acoes[
                                                                                        indexAcao
                                                                                      ]
                                                                                        .codigo
                                                                                  }
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa",
                                                                                class:
                                                                                  _vm
                                                                                    .jsonHeaders[
                                                                                    indexHeader
                                                                                  ]
                                                                                    .acoes[
                                                                                    indexAcao
                                                                                  ]
                                                                                    .icone
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              "  " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .jsonHeaders[
                                                                                    indexHeader
                                                                                  ]
                                                                                    .acoes[
                                                                                    indexAcao
                                                                                  ]
                                                                                    .nome
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "disabled-content"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa",
                                                                                class:
                                                                                  _vm
                                                                                    .jsonHeaders[
                                                                                    indexHeader
                                                                                  ]
                                                                                    .acoes[
                                                                                    indexAcao
                                                                                  ]
                                                                                    .icone
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              "  " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .jsonHeaders[
                                                                                    indexHeader
                                                                                  ]
                                                                                    .acoes[
                                                                                    indexAcao
                                                                                  ]
                                                                                    .nome
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : undefined
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm.jsonHeaders[indexHeader].propriedade.includes(
                "dadosCartorio"
              ) &&
              _vm.jsonHeaders[indexHeader].propriedade !==
                "dadosCartorio.matricula" &&
              _vm.jsonHeaders[indexHeader].propriedade !==
                "dadosCartorio.descricaoMemorial"
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.jsonHeaders[indexHeader].titulo,
                      prop: _vm.jsonHeaders[indexHeader].propriedade,
                      formatter: _vm.jsonHeaders[indexHeader].formatter
                        ? _vm.jsonHeaders[indexHeader].formatter
                        : function(row, col, value, index) {
                            return value
                          },
                      width: "150",
                      align: "left"
                    }
                  })
                : _vm._e(),
              _vm.jsonHeaders[indexHeader].propriedade.includes(
                "dadosCartorio"
              ) &&
              _vm.jsonHeaders[indexHeader].propriedade ===
                "dadosCartorio.descricaoMemorial"
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.jsonHeaders[indexHeader].titulo,
                      prop: _vm.jsonHeaders[indexHeader].propriedade,
                      width: "150",
                      align: "left"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    title:
                                      scope.row.dadosCartorio.descricaoMemorial
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.jsonHeaders[indexHeader].formatter(
                                        scope.row.dadosCartorio
                                          .descricaoMemorial
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm.jsonHeaders[indexHeader].propriedade ===
              "dadosCartorio.matricula"
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.jsonHeaders[indexHeader].titulo,
                      prop: _vm.jsonHeaders[indexHeader].propriedade,
                      align: "center",
                      "align-header": "center",
                      width: "230",
                      fixed: "fixed"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "Digite a matrícula"
                                    },
                                    model: {
                                      value: scope.row.dadosCartorio.matricula,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row.dadosCartorio,
                                          "matricula",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "scope.row.dadosCartorio.matricula"
                                    }
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content:
                                          "Clique para finalizar após preencher a matrícula",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "ml-5",
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function($event) {
                                              return _vm.salvarMatricula(
                                                scope.row.dadosCartorio
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-save"
                                          }),
                                          _c("span", { staticClass: "ml-5" }, [
                                            _vm._v("Finalizar")
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e()
            ]
          })
        ],
        2
      ),
      _vm.showPagination
        ? _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next",
                  total: _vm.totalElements,
                  "page-size": _vm.CONFIGS.TAMANHO_PAGINACAO,
                  "current-page": _vm.pagina + 1
                },
                on: { "current-change": _vm.alterarPagina }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.showTotalListagem
        ? _c("div", { staticClass: "contador-total" }, [
            _c("span", [
              _vm._v("Total de registros: " + _vm._s(_vm.totalElements))
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row-buttoms" },
        [
          _vm.showCsvButton
            ? _c(
                "div",
                { staticClass: "exportar-csv" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("exportarCsvFiltroAnalise")
                        }
                      }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fal fa-file-csv" }),
                        _vm._v("  Exportar CSV")
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.showButtonExportarTitulos
            ? _c(
                "div",
                { staticClass: "exportar-titulos" },
                [
                  _c("el-button", { on: { click: _vm.exportarTitulos } }, [
                    _c("span", [
                      _c("i", { staticClass: "fa fa-download" }),
                      _vm._v("  " + _vm._s(_vm.textoButtonExportarTitulo))
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.showModal
            ? _c("app-modal-nova", {
                attrs: {
                  tipo: _vm.tipoModal,
                  showModal: _vm.showModal,
                  width: _vm.widthModal,
                  height: _vm.heightModal,
                  padding: 0
                },
                on: {
                  closeModal: function($event) {
                    _vm.showModal = false
                  }
                }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "btn-vincular" },
            [
              _vm.showButtonInternal && _vm.showButtonOrdemServico
                ? _c("el-button", { on: { click: _vm.selected } }, [
                    _c("span", [
                      _c("i", { staticClass: "fa fa-users" }),
                      _vm._v("  Vincular Equipe")
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-vincular" },
            [
              _vm.showButtonAssinatura
                ? _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.disableButtonAssinaturaTitulo },
                      on: { click: _vm.assinarTitulos }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fa fa-pager" }),
                        _vm._v("  " + _vm._s(_vm.textoButtonAssinatura))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-vincular" },
            [
              _vm.showButtonAssinaturaGov
                ? _c(
                    "el-button",
                    {
                      staticClass: "el-button-gov",
                      attrs: { disabled: _vm.disableButtonAssinaturaTitulo },
                      on: { click: _vm.assinarTitulosGov }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fa fa-pencil-alt" }),
                        _vm._v("  " + _vm._s(_vm.textoButtonAssinaturaGov))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-vincular" },
            [
              _vm.showButtonEnviarProcessos
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: "Não há processos preenchidos",
                        placement: "top",
                        disabled: !_vm.disableButtonEnviarProcessos
                      }
                    },
                    [
                      !_vm.disableButtonEnviarProcessos
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                { on: { click: _vm.enviarProcessos } },
                                [
                                  _c("span", [
                                    _c("i", { staticClass: "fa fa-check" }),
                                    _vm._v("  Encaminhar processo(s)")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "disabled-content" },
                            [
                              _c(
                                "el-button",
                                { staticClass: "cursor-not-allowed" },
                                [
                                  _c("span", [
                                    _c("i", { staticClass: "fa fa-check" }),
                                    _vm._v("  Encaminhar processo(s)")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-vincular" },
            [
              _vm.showRegerar && _vm.showButtonRegerar
                ? _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.listaId },
                      on: { click: _vm.regerarProcesso }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "el-icon-refresh" }),
                        _vm._v("  Regerar Selecionados")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-vincular" },
            [
              _vm.showSolicitarAcesso
                ? _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.listaId },
                      on: { click: _vm.solicitarAcesso }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "fa fa-envelope" }),
                        _vm._v("  Solicitar Acesso")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-728534a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728534a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppListagem.vue
// module id = null
// module chunks = 